import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Content, Loader } from 'rsuite';
import {
  ItemType,
  PackageType,
  InventoryTypesLabel
} from '../../../../constants/inventory/InventoryTypes';
import {
  InventoryItemType,
  InventoryPackageType
} from '../../../../interfaces/inventory';
import {
  inventoryItemsPath,
  inventoryViewItemPath,
  inventoryPackagesPath,
  inventoryViewPackagePath
} from '../../../Paths';
import * as PERMISSIONS from '../../../../constants/permissions/inventory';
import { modifyAccess } from '../../../../helpers/permission';
import AccessControl from '../../../../components/AccessControl';
import AccessDenied from '../../../../components/AccessDenied';
import Breadcrumb from '../../../../components/Breadcrumb';
import InventoryItemForm from '../../../../containers/inventory/ItemForm';
import InventoryPageLayout from '../../../../containers/inventory/PageLayout';
import PageHeader from '../../../../components/PageHeader';

const pathByType = {
  [ItemType]: {
    list: inventoryItemsPath,
    view: inventoryViewItemPath
  },
  [PackageType]: {
    list: inventoryPackagesPath,
    view: inventoryViewPackagePath
  }
};

const permissionByType = {
  [ItemType]: PERMISSIONS.ITEM,
  [PackageType]: PERMISSIONS.PACKAGE
};

export default class EditInventoryItem extends Component {
  static propTypes = {
    item: PropTypes.oneOfType([InventoryItemType, InventoryPackageType]),
    type: PropTypes.oneOf([ItemType, PackageType]).isRequired,
    isFetchingItem: PropTypes.bool.isRequired,
    isSaved: PropTypes.bool.isRequired,
    onInit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  static defaultProps = {
    item: null
  };

  constructor(props) {
    super(props);
    this.state = { isInit: false, redirectToView: false };
  }

  componentDidMount() {
    const { isInit } = this.state;
    const { onInit } = this.props;
    if (!isInit) {
      onInit();
      this.setState({ isInit: true });
    }
  }

  componentDidUpdate({ isSaved: prevIsSaved }) {
    const { isSaved } = this.props;
    if (!prevIsSaved && isSaved) {
      this.onItemSaved();
    }
  }

  onItemSaved = () => {
    this.setState({ redirectToView: true });
  };

  get viewItemPath() {
    const { item, type } = this.props;
    return pathByType[type].view.replace(':id', item.id);
  }

  renderRedirectToView() {
    this.setState({ redirectToView: false });
    return <Redirect to={this.viewItemPath} />;
  }

  renderBreadcrumb() {
    const { item, type } = this.props;
    return (
      <Breadcrumb
        items={[
          {
            path: pathByType[type].list,
            label: 'Items'
          },
          {
            path: this.viewItemPath,
            label: item.name
          },
          { label: `Edit ${InventoryTypesLabel[type]}` }
        ]}
      />
    );
  }

  render() {
    const { redirectToView } = this.state;
    const { isFetchingItem, type, item, onSubmit } = this.props;

    if (redirectToView) {
      return this.renderRedirectToView();
    }

    return (
      <InventoryPageLayout>
        <AccessControl
          allowOnlyFor={modifyAccess(permissionByType[type])}
          fallback={<AccessDenied />}
        >
          {item && this.renderBreadcrumb()}
          <PageHeader title={`Edit ${InventoryTypesLabel[type]}`} />
          <Content>
            {isFetchingItem && !item ? (
              <Loader backdrop content="loading..." vertical />
            ) : (
              <InventoryItemForm type={type} item={item} onSubmit={onSubmit} />
            )}
          </Content>
        </AccessControl>
      </InventoryPageLayout>
    );
  }
}
